import React, { useState, useEffect } from 'react';
import { Form, Input, InputNumber, Select, AutoComplete } from 'antd';
import dayjs from 'dayjs';
import CustomDatePicker from './CustomDatePicker';
import { getUniquePaymentAccounts } from '../services/userService';

const { Option } = Select;

const UserForm = ({ form, initialValues, jobOptions = [] }) => {
  const [paymentAccountOptions, setPaymentAccountOptions] = useState([]);
  const [paymentAccountLoading, setPaymentAccountLoading] = useState(false);

  // Fetch payment account suggestions on component mount
  useEffect(() => {
    const fetchPaymentAccounts = async () => {
      setPaymentAccountLoading(true);
      try {
        const response = await getUniquePaymentAccounts();
        const accounts = response.paymentAccounts || [];
        setPaymentAccountOptions(accounts.map(account => ({ value: account, label: account })));
      } catch (error) {
        console.error('Error fetching payment accounts:', error);
        // Don't show error to user, just log it
      } finally {
        setPaymentAccountLoading(false);
      }
    };

    fetchPaymentAccounts();
  }, []);

  // Convert DateOfJoining to dayjs format if it exists
  console.log(initialValues);
  const processedInitialValues = initialValues ? {
    ...initialValues,
    dateOfJoining: initialValues.DateOfJoining ? dayjs(initialValues.DateOfJoining) : null,
    fullName: initialValues.FullName,
    mobileNumber: initialValues.MobileNumber,
    aadhaarCard: initialValues.AadhaarCard,
    rate: initialValues.Rate,
    job: initialValues.Job,
    paymentAccount: initialValues.PaymentAccount,
    employmentType: initialValues.EmploymentType,
    userType: initialValues.UserType,
  } : {};

  // Update form values when initialValues change (for editing)
  useEffect(() => {
    if (initialValues && form) {
      const processedValues = {
        fullName: initialValues.FullName,
        mobileNumber: initialValues.MobileNumber,
        aadhaarCard: initialValues.AadhaarCard,
        rate: initialValues.Rate,
        job: initialValues.Job,
        paymentAccount: initialValues.PaymentAccount,
        employmentType: initialValues.EmploymentType,
        userType: initialValues.UserType,
        dateOfJoining: initialValues.DateOfJoining ? dayjs(initialValues.DateOfJoining) : null,
      };
      form.setFieldsValue(processedValues);
    }
  }, [initialValues, form]);

  return (
    <Form form={form} layout="vertical" name="user_form" initialValues={processedInitialValues}>
      <Form.Item
        name="fullName"
        label="Full Name"
        rules={[{ required: true, message: 'Please input the full name!' }]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        name="mobileNumber"
        label="Mobile Number"
        rules={[{ required: true, message: 'Please input the mobile number!' }]}
      >
        <Input disabled={!!initialValues} />
      </Form.Item>
      <Form.Item
        name="aadhaarCard"
        label="Aadhaar Card"
      >
        <Input />
      </Form.Item>
      <Form.Item
        name="rate"
        label="Rate"
        rules={[]}
      >
        <InputNumber style={{ width: '100%' }} placeholder="Enter rate for salary calculation" />
      </Form.Item>
      <Form.Item
        name="dateOfJoining"
        label="Date of Joining"
      >
        <CustomDatePicker 
          style={{ width: '100%' }} 
          format="YYYY-MM-DD" 
          showToday={true}
          disabledDate={(current) => current && current > dayjs().endOf('day')}
          placeholder="Select Date of Joining"
        />
      </Form.Item>
      <Form.Item
        name="job"
        label="Job"
        rules={[{ required: true, message: 'Please input the job!' }]}
      >
        <AutoComplete
          options={jobOptions}
          placeholder="Enter or select job"
          filterOption={(inputValue, option) =>
            option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
          }
        />
      </Form.Item>
      <Form.Item
        name="paymentAccount"
        label="Payment Account"
      >
        <AutoComplete
          options={paymentAccountOptions}
          placeholder="Name of person where salary is paid (Optional)"
          allowClear
          showSearch
          filterOption={(inputValue, option) =>
            option?.value?.toLowerCase().includes(inputValue.toLowerCase())
          }
          notFoundContent={paymentAccountLoading ? 'Loading...' : 'No suggestions found'}
        />
      </Form.Item>
      <Form.Item
        name="employmentType"
        label="Employment Type"
        rules={[{ required: true, message: 'Please select the employment type!' }]}
      >
        <Select>
          <Option value="FIXED">Fixed</Option>
          <Option value="SHIFT">Shift</Option>
        </Select>
      </Form.Item>
      <Form.Item
        name="userType"
        label="User Type"
        rules={[{ required: true, message: 'Please select the user type!' }]}
      >
        <Select>
          <Option value="WORKER">Worker</Option>
          <Option value="LEAD">Lead</Option>
          <Option value="SUPERVISOR">Supervisor</Option>
        </Select>
      </Form.Item>
    </Form>
  );
};

export default UserForm; 